import { LOGIN, LOGOUT, REGISTER_OTP, USER_LOADED,USER_FAIL } from "../actions/types";

const initialState = {
  token: localStorage.getItem("AppToken"),
  isAuthenticated: false,
  loading: true,
  user: {},
};

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGIN:
      localStorage.setItem("AppToken", payload.token);
      localStorage.setItem("user", payload.user._id);
      return {
        ...state,
        token: payload.token,
        isAuthenticated: true,
        loading: false,
        user: payload.user,
      };
    case LOGOUT:
      localStorage.removeItem("AppToken");
      localStorage.removeItem("user");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
      };
    case REGISTER_OTP:
      localStorage.setItem("AppToken", payload.token);
      localStorage.setItem("user", payload.user._id);
      return {
        ...state,
        token: payload.token,
        isAuthenticated: true,
        loading: false,
        user: payload.user,
      };
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: payload.user ? true : false,
        loading: false,
        user: payload.user,
      };
    case USER_FAIL:
      localStorage.removeItem("AppToken");
      localStorage.removeItem("user");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
      };
    default:
      return state;
  }
};
export default authReducer;
